export class QuotationState {

    // constructor(quotationId? : number,quotationNo? :string, optionId?:number, status?:string, categories?: QuotationCensusCategory[]) {  
    //     this.quotationId = quotationId;
    //     this.quotationNo = quotationNo;
    //     this.optionId = optionId;
    //     this.status = status;
    //     this.categories = categories;
    // }
    constructor() { }

    mode: string;
    status: string;
    quotationId: number;
    expQuoteId: string;
    quotationNo: string;
    optionId: number;
    productId: number;
    isClaimExpAvailable: boolean;
    isSubmitted: boolean;
    isFreshGroup: boolean;
    quotingInsurerId: number;
    isRiderCovered: boolean;
    quotingTPAId: number;
    data: any;
    isRenewalScheme:boolean;
    censusTypeId: number;
    currencyCode:string;
    isReInsurerLogin: boolean;
    isDependentsEnabled: boolean;
    isWcEnabled: boolean;
    selectedPlanPresetId: number = 0;
    selectionType: string = "";
    quotationDate: Date;
    hasMafDisclaimer: boolean;
    redirectTo: string = "";
}
